import { createContext } from 'react';
import { FormDataContextValue } from '~/types';

export const FormDataContext = createContext<FormDataContextValue | undefined>(undefined);
